import * as React from 'react';
import { Dialog } from '../../entries/components';
import { Icon } from '../../entries/components';
import { useState } from 'react';
import './ButtonModal.scss';

export interface ButtonModalProps {
  buttonText?: string;
  buttonCss?: string;
  modalAction?: string;
  modalHeading: string;
  modalBody: string;
  modalCancelText?: string;
  modalCancelCss?: string;
  modalActionText: string;
  modalActionCss: string;
  modalActionUrl?: string;
  callBackLink?: string;
  isButtonDisabled?: boolean;
  onActionCompleted?(): void;
  isModalOpen: boolean;
  passData: any;
  okAction?(): void;
  rowIndex?: number;
  closeConfirm: any;
  isModalBodyHtml?: boolean;
}

export interface ButtonModalState {
  isModalOpen: boolean;
}

/**
 * Renders a button that opens a modal dialogue with the given properties. See [[ButtonModalProps]] for available options.
 */
export const ButtonModal: React.FC<ButtonModalProps> = (props) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(props.isModalOpen);

  const defaultProps = {
    modalActionUrl: '',
    callBackLink: '',
    onActionCompleted: () => {},
  };

  const onActionCompleted = () => props.onActionCompleted();

  const openConfirm = (e: React.MouseEvent) => {
    e.preventDefault();
    setIsModalOpen(true);
  };

  const redirect = () => props.onActionCompleted;

  const doOkAction = () => {
    if (props.okAction) {
      props.okAction();
    } else {
      props.passData(props.rowIndex);
    }
  };

  const doCancelAction = () => {
    props.closeConfirm();
  };

  return (
    <div>
      <Dialog isOpen={props.isModalOpen} onRequestClose={props.closeConfirm}>
        <button type="button" onClick={props.closeConfirm} className="close">
          <Icon isAriaHidden={false} ariaLabel="Stäng" iconType="ic_close_white_24px" />
        </button>
        <div className="header">
          <h2>{props.modalHeading}</h2>
        </div>
        {!props.isModalBodyHtml && <p>{props.modalBody}</p>}
        {props.isModalBodyHtml === true && <p dangerouslySetInnerHTML={{ __html: props.modalBody }}></p>}
        <div className="footer">
          <button type="button" className={props.modalActionCss} onClick={doOkAction}>
            {props.modalActionText}
          </button>
          {props.modalCancelText && (
            <button type="button" className={props.modalCancelCss} onClick={doCancelAction}>
              {props.modalCancelText}
            </button>
          )}
        </div>
      </Dialog>
    </div>
  );
};
